"use strict";
/*
 * Created on 22. 2. 2019
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Price change report prices converter.
 *
 * @author SKu
 */


var PriceChangeReportPricesDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PriceChangeReportPricesDTOConverter, _DataObjectConverter_);

  function PriceChangeReportPricesDTOConverter() {
    _classCallCheck(this, PriceChangeReportPricesDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceChangeReportPricesDTOConverter).apply(this, arguments));
  }

  return PriceChangeReportPricesDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PriceChangeReportPricesDTOConverter = PriceChangeReportPricesDTOConverter;